/**
 * External Dependencies
 */
import React, { Component } from 'react';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import Cookies from 'js-cookie';

/**
 * Component
 */
class VideoView extends Component {
    render() {
        const video_page = Cookies.get('video_page');
        return (
            <PageWrap>
             <div style={{display:video_page == "true"  ? "block" :"none"}}>
                    <AsyncComponent component={ () => import( './content' ) } />
            </div> 
            </PageWrap>
        );
    }
}

export default VideoView;
